import { Component, OnInit } from "@angular/core";
import { MessagingService } from "./services/messaging.service";
import { OAuthService } from "./services/o-auth";
import { VersionCheckService } from "./services/check-version/version-check.service";

@Component({
  // tslint:disable-next-line
  selector: "body",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  constructor(
    public msgService: MessagingService,
    public auth: OAuthService,
    private check: VersionCheckService
  ) {}

  ngOnInit() {
    // this.msgService.getPermission()
    // this.msgService.receiveMessage()
    // this.check.initVersionCheck("https://www.golfhubber.com/club/");
  }
}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/app.component.ts